new WOW().init();

// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener("DOMContentLoaded", function () {
  var slideshowElement = document.getElementById("tb-home-slideshow");
  if (slideshowElement) {
    document.body.classList.add("common-home");
  }
});

// ========================== BACK TO TOP ==========================
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $("#return-to-top").fadeIn(200);
  } else {
    $("#return-to-top").fadeOut(200);
  }
});
$("#return-to-top").click(function () {
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    500
  );
});

// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
$(document).ready(function () {
  $(".list-menu__item").on("click", function () {
    $("#Details-menu-drawer-container").removeAttr("open");
    $(".header__icon").attr("aria-expanded", "false");
    $("body").removeClass("overflow-hidden-tablet");
    $(".menu-opening").removeClass("menu-opening");
  });
});

// ========================== CUSTOMERS OWL-CAROUSEL ==========================
$(document).ready(function () {
  $("#tb-customers .tb-customer-wrapper").owlCarousel({
    items: 5,
    margin: 30,
    nav: false,
    dots: true,
    loop: false,
    responsive: {
      0: {
        items: 1,
      },
      631: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });

  $("#tb-home-slideshow .swiper-wrapper").owlCarousel({
     items: 1,
  nav: false,
  dots: false,
  navText:false,
  autoplay: false,
  mouseDrag: false,
  touchDrag: false,
  pullDrag: false,
  });
  $('.tb-splide-wrapper.owl-carousel').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false, 
      // animateIn: 'flipInX',
      // animateOut: 'fadeOut',
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

     $('#tb-video-cms .owl-carousel').owlCarousel({
      loop: false,
      margin: 20,
      nav: false,
      dots: true,
      animateOut: 'fadeOut',
      animateIn: 'flipInX',
      responsive: {
        0: { items: 1 },
        481: { items: 2 },
        768: { items: 3 },
        992: { items: 4 },
        1300: { items: 4 }
      }
    })
});


$('#tb-testimonial .owl-carousel').owlCarousel({
      loop: false,
      margin: 30,
      nav: false,
      dots: true,
      animateOut: 'fadeOut',
      animateIn: 'flipInX',
      responsive: {
        0: { items: 1 },
        576: { items: 2, margin:15 },
        768: { items: 2 },
        992: { items: 3 }
      }
    })

// ========================== RELATED PRODUCT OWL-CAROUSEL ==========================
$(document).ready(function () {
  $("#productThumbs").owlCarousel({
    items: 4,
    margin: 15,
    nav: true,
    dots: false,
    loop: false,
    responsive: {
      0: {
        items: 2,
      },
      481: {
        items: 3,
      },
      576: {
        items: 4,
      },
      768: {
        items: 5,
      },
      992: {
        items: 3,
      },
      1300: {
        items: 4,
      },
    },
  });
});

// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
  if ($(window).width() < 992) {
    $(".tb-footer-center .footer-column h5").addClass("toggle");
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    var Accordions = function (el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
      var link = this.el.find(".toggle");
      link.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    Accordions.prototype.dropdown = function (e) {
      var $el = e.data.el;
      ($this = $(this)), ($next = $this.next());
      $next.slideToggle();
      $this.parent().toggleClass("active");
      if (!e.data.multiple) {
        $el
          .find(".tb-footer-center .footer-column")
          .not($next)
          .slideUp()
          .parent()
          .removeClass("active");
      }
    };
    var accordions = new Accordions(
      $(".tb-footer-center .footer-column"),
      false
    );
  } else {
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    $(".tb-footer-center .footer-column h5").removeClass("toggle");
  }
}
$(document).ready(function () {
  footerToggle();
});
$(window).resize(function () {
  footerToggle();
});


// ========================== RELATED PRODUCT ==========================
$(document).ready(function () {
  // Add active class to the first image by default
  $(".tb-related-product:first").parent().addClass("active");

  // Attach click event listener to each related product thumbnail
  $(".tb-related-product").click(function () {
    // Remove active class from all related product thumbnails and their parent containers
    $(".tb-related-product").parent().removeClass("active");

    // Add active class to the clicked related product thumbnail and its parent container
    $(this).addClass("active").parent().addClass("active");

    // Get the URL of the clicked thumbnail's image
    var thumbnailSrc = $(this).attr("src");

    // Update the source attribute of the main product image
    // $('.zoom').css('background-image', 'url(' + thumbnailSrc + ')');
    $("#productPhotoImg").attr("src", thumbnailSrc);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Add event listener for mouseenter event on .zoom element
  var zoomElement = document.querySelector(".zoom");
  if (zoomElement) {
    zoomElement.addEventListener("mouseenter", function () {
      // Get the URL of the main product image
      var img_url = document
        .getElementById("productPhotoImg")
        .getAttribute("src");
      // Set background image of .zoom element to the main product image
      this.style.backgroundImage = "url(" + img_url + ")";
    });

    // Add event listener for mouseleave event on .zoom element
    zoomElement.addEventListener("mouseleave", function () {
      // Remove background image when mouse leaves the .zoom element
      this.style.backgroundImage = "none";
    });
  }
});

function zoom(e) {
  var zoomer = e.currentTarget;
  e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  e.offsetY ? (offsetY = e.offsetY) : (offsetY = e.touches[0].pageY);
  x = (offsetX / zoomer.offsetWidth) * 100;
  y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + "% " + y + "%";
}

/* ------------ Start TemplateBunch Parallax JS ------------ */
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
if (!isMobile) {
  if ($("#tb-ingredients").length) {
    $("#tb-ingredients").sitManParallex({ invert: false });
  }
} else {
  $("#tb-ingredients").sitManParallex({ invert: true });
}

/* ------------ End TemplateBunch Parallax JS ------------ */

// ========================== VIDEO ==========================
document.addEventListener("DOMContentLoaded", function () {
  const videoWrappers = document.querySelectorAll(".video-wrapper");

  videoWrappers.forEach((wrapper) => {
    const banner = wrapper.querySelector(".video-banner");
    const playButton = wrapper.querySelector(".play-button");
    const video = wrapper.querySelector(".short-video");

    wrapper.addEventListener("click", function () {
      if (video.style.display === "none") {
        // Show video and play
        banner.style.display = "none";
        playButton.style.display = "none";
        video.style.display = "block";
        video.play();
      } else {
        // Stop video and show banner
        video.pause();
        video.style.display = "none";
        banner.style.display = "block";
        playButton.style.display = "block";
      }
    });

    // Stop video and reset when it ends
    video.addEventListener("ended", function () {
      video.style.display = "none";
      banner.style.display = "block";
      playButton.style.display = "block";
    });
  });
});

/* ------------ End  Video JS ------------ */


// ========================== INSPECT CLOSE ==========================
// Prevent Developer Tools, Right-Click, and Restricted Shortcuts
document.addEventListener(
  "keydown",
  function (event) {
    if (
      event.keyCode === 123 || // F12
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 67 || event.keyCode === 99)) || // Ctrl+Shift+C or c
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 73 || event.keyCode === 105)) || // Ctrl+Shift+I or i
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 74 || event.keyCode === 106)) || // Ctrl+Shift+J or j
      (event.ctrlKey && event.keyCode === 85) || // Ctrl+U
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 77 || event.keyCode === 109)) || // Ctrl+Shift+M or m
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 69 || event.keyCode === 101)) || // Ctrl+Shift+E or e
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 84 || event.keyCode === 116)) || // Ctrl+Shift+T or t
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 88 || event.keyCode === 120)) || // Ctrl+Shift+X or x
      (event.ctrlKey && event.altKey && event.keyCode === 83) || // Ctrl+Alt+S
      (event.metaKey && event.shiftKey && event.keyCode === 80) || // Cmd+Shift+P (Mac)
      (event.ctrlKey && event.keyCode === 83) || // Ctrl+S
      (event.metaKey && event.keyCode === 83) // Cmd+S (Mac)
    ) {
      event.preventDefault();
    }
  },
  false
);

// Prevent context menu
document.addEventListener(
  "contextmenu",
  function (event) {
    event.preventDefault();
  },
  false
);

// Prevent mouse actions
document.addEventListener(
  "mousedown",
  function (event) {
    if (
      event.button === 2 || // Right-click
      (event.ctrlKey && event.button === 0) || // Ctrl+Left-click
      (event.metaKey && event.button === 0) // Cmd+Left-click on Mac
    ) {
      event.preventDefault();
    }
  },
  false
);


